/**
 * Base paths for different asset types
 */
export const ASSET_PATHS = {
    IMAGES: 'assets/images/',
    ICONS: 'assets/icons',
    LOGOS: 'assets/logos',
    ANIMATION: 'assets/animation',
    FAVICON: 'assets/images/',
    MOCKS: 'assets/mock/',
} as const

/**
 * Image asset paths
 */
export const IMAGE_PATHS = {
    NAVIGATOR_LOGO: `${ASSET_PATHS.IMAGES}nav_logo.png`,
    AVATAR: `${ASSET_PATHS.IMAGES}avatar.png`,
    VIEW_PROPOSAL_DPS_CREST: `${ASSET_PATHS.IMAGES}view-proposal/dps-crest.jpg`,
    VIEW_PROPOSAL_STAR_BADGE: `${ASSET_PATHS.IMAGES}view-proposal/star-badge.jpg`,
    VIEW_PROPOSAL_GLOBE_RIVE: `${ASSET_PATHS.ANIMATION}/globe.riv`,
} as const

/**
 * Icon asset paths
 */
export const ICON_PATHS = {
    RIGHT_ARROW: `${ASSET_PATHS.IMAGES}icons/right-arrow.svg`,
    EXPAND_COLLAPSE: `${ASSET_PATHS.IMAGES}icons/expand-collapse.svg`,
    SCHOOL: `${ASSET_PATHS.IMAGES}icons/school-icon.svg`,
    CONTACTS: `${ASSET_PATHS.IMAGES}icons/contacts-icon.svg`,
    CHECK_CIRCLE: `${ASSET_PATHS.IMAGES}icons/check-circle-icon.svg`,
    ALERT_CIRCLE: `${ASSET_PATHS.IMAGES}icons/alert-circle-icon.svg`,
    CLOSE: `${ASSET_PATHS.ICONS}/close-icon.svg`,
    CLOCK: `${ASSET_PATHS.IMAGES}icons/clock-icon.svg`,
    WAITING: `${ASSET_PATHS.IMAGES}icons/waiting-icon.svg`,
    TRENDING_UP: `${ASSET_PATHS.ICONS}/trending-up.svg`,
    TRENDING_DOWN: `${ASSET_PATHS.ICONS}/trending-down.svg`,
    INFO: `${ASSET_PATHS.IMAGES}icons/info-icon.svg`,
    CONTACT_PERSON: `${ASSET_PATHS.IMAGES}icons/contact-person-icon.svg`,
    EMPTY_DOCUMENT: `${ASSET_PATHS.ICONS}/empty-document.svg`,
    EYE: `${ASSET_PATHS.ICONS}/eye.svg`,
    WARNING: `${ASSET_PATHS.ICONS}/warning.svg`,
    SEARCH: `${ASSET_PATHS.ICONS}/search.svg`,
    LIST_VIEW: `${ASSET_PATHS.ICONS}/list-view.svg`,
    GRID_VIEW: `${ASSET_PATHS.ICONS}/grid-view.svg`,
    FILTER: `${ASSET_PATHS.ICONS}/filter.svg`,
    DROPDOWN_ARROW: `${ASSET_PATHS.ICONS}/dropdown-arrow.svg`,
    CLOSE_ICON: `${ASSET_PATHS.ICONS}/close.svg`,
    DOCUMENT: `${ASSET_PATHS.ICONS}/empty-document.svg`,
    VIEW_ICON: `${ASSET_PATHS.ICONS}/eye.svg`,
    RESET: `${ASSET_PATHS.ICONS}/reset.svg`,
    SORT_ICON: `${ASSET_PATHS.ICONS}/sort.svg`,
} as const

/**
 * Logo asset paths
 */
export const LOGO_PATHS = {
    MINDSPARK: `${ASSET_PATHS.LOGOS}/mindspark-logo.png`,
    CARES: `${ASSET_PATHS.LOGOS}/cares-logo.png`,
    ASSET: `${ASSET_PATHS.LOGOS}/asset-logo.png`,
    // Add more logo paths here
} as const

/**
 * Product logo mapping for dynamic logo selection
 * Maps product type keywords to their corresponding logo paths
 */
export const PRODUCT_LOGO_MAP = [
    { key: 'mindspark', logo: LOGO_PATHS.MINDSPARK },
    { key: 'cares', logo: LOGO_PATHS.CARES },
    { key: 'asset', logo: LOGO_PATHS.ASSET },
] as const

/**
 * Favicon paths
 */
export const FAVICON_PATHS = {
    DEFAULT: `${ASSET_PATHS.FAVICON}logo.png`,
} as const

/**
 * Helper function to get full asset path
 * @param type - Asset type (IMAGES, ICONS, LOGOS, FAVICON, MOCKS)
 * @param filename - Asset filename
 * @returns Full asset path
 */
export const getAssetPath = (type: keyof typeof ASSET_PATHS, filename: string): string =>
    `${ASSET_PATHS[type]}${filename}`
